<template>
<div class="rank-item box">
    <div class="row ">
        <div class="col-md-4">
            <img class="img-circle img-fluid img-rank" :src="avatar" alt="">
        </div>
        <div class="col-md-8">
            <div class="text-white rank-name">{{ name }}</div>
            <div class="text-white rank-total">{{ revenue }}</div>
        </div>
    </div>
</div>

</template>
<script>
export default {
    name: 'RankItem',
    props: ['name','avatar','percent', 'revenue'],
}
</script>

<style scoped>
    .box{
        padding: 0px;
    }
    .rank-name{
        margin-top: 0.5em;
        font-size: 1.3em;
        font-weight: 500;
    }
    .rank-item{
        margin: 2em 1em;
        background: url(../../assets/box-sale.png);
        background-size:cover;
        border-radius: 20px;
        overflow: hidden;
    }
    .img-rank{
        overflow: hidden;
        width: 70px;
        height: 70px;
        margin: 1em;
    }
    
</style>



// WEBPACK FOOTER //
// src/components/Rank/RankItem.vue